import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BASE_URL } from "../config/api";
import Swal from "sweetalert2";

const AddReminder = () => {
  const [title, setTitle] = useState("");
  const [time, setTime] = useState("");
  const [staffId, setStaffId] = useState("");
  const [staffList, setStaffList] = useState([]);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  // 👇 Prevent selecting previous date/time
  const getMinDateTime = () => {
    const now = new Date();
    now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
    return now.toISOString().slice(0, 16);
  };

  // 👇 Convert datetime-local (2025-01-08T14:30) to API format (2025-01-08 14:30:00)
  const formatDateTime = (dt) => {
    return dt.replace("T", " ") + ":00";
  };

  // Fetch staff list
  useEffect(() => {
    fetch("https://pbhrm.com/api/staff")
      .then((res) => res.json())
      .then((data) => {
        if (data.status === 1) {
          setStaffList(data.data);
        }
      })
      .catch((err) => {
        console.error("Error fetching staff:", err);
      });
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!title || !time || !staffId) {
      setError("Title, Time, and Staff are required");
      return;
    }

    const payload = {
      title,
      time: formatDateTime(time), // 👈 Fixed time format
      staff_id: parseInt(staffId),
    };

    try {
      const res = await fetch(`${BASE_URL}reminders`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const result = await res.json();

      if (result.status === 1) {
        Swal.fire({
          icon: "success",
          title: result.message,
        });
        navigate("/RemindersList");
      } else {
        setError(result.message || "Failed to create reminder");
      }
    } catch (err) {
      console.error("Error:", err);
      setError("Something went wrong. Please try again.");
    }
  };

  return (
    <div id="main">
      <header className="mb-3">
        <a href="#" className="burger-btn d-block d-xl-none">
          <i className="bi bi-justify fs-3"></i>
        </a>
      </header>

      <div className="page-heading">
        <div className="page-title">
          <div className="row">
            <div className="col-12 col-md-6 order-md-1 order-last">
              <h3>Add Reminder</h3>
            </div>
          </div>
        </div>
      </div>

      <section className="section">
        <div className="row" id="basic-table">
          <div className="col-12 col-md-12">
            <div className="card">
              <div className="card-header">
                <h4>Create a New Reminder</h4>
              </div>
              <div className="card-body">
                {error && <div className="alert alert-danger">{error}</div>}

                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label htmlFor="title" className="form-label">
                      Title
                    </label>
                    <input
                      type="text"
                      id="title"
                      className="form-control"
                      placeholder="Enter reminder title"
                      value={title}
                      onChange={(e) => setTitle(e.target.value)}
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="time" className="form-label">
                      Time
                    </label>
                    <input
                      type="datetime-local"
                      id="time"
                      className="form-control"
                      value={time}
                      min={getMinDateTime()} // 👈 Block past date/time
                      onChange={(e) => setTime(e.target.value)}
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="staffId" className="form-label">
                      Select Staff
                    </label>
                    <select
                      id="staffId"
                      className="form-control"
                      value={staffId}
                      onChange={(e) => setStaffId(e.target.value)}
                    >
                      <option value="">-- Select Staff --</option>
                      {staffList.map((staff) => (
                        <option key={staff.id} value={staff.id}>
                          {staff.name} ({staff.email})
                        </option>
                      ))}
                    </select>
                  </div>

                  <button type="submit" className="btn btn-primary">
                    Add Reminder
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AddReminder;
